/*
 * @format
 *
 * Functions to manage  schedules
 */

export const validDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

// returns an array of the schedule for a single day
export const getDaySchedule = (day, schedule) => {
  const thisDayIndex = schedule.findIndex(x => x.day === day);
  return schedule[thisDayIndex].events;
};

// Compare 2 day schedule to see if they are different
function compareDaySchedules(pendingSchedule, latestSchedule) {
  if (pendingSchedule.length !== latestSchedule.length) {
    return false;
  }

  const sortedPendingSchedule = pendingSchedule.sort(
    (a, b) => parseFloat(a.startTime) - parseFloat(b.startTime),
  );

  const sortedLatestSchedule = latestSchedule.sort(
    (a, b) => parseFloat(a.startTime) - parseFloat(b.startTime),
  );

  for (let index = 0; index < sortedPendingSchedule.length; index += 1) {
    if (
      sortedPendingSchedule[index].startTime !==
        sortedLatestSchedule[index].startTime ||
      sortedPendingSchedule[index].setpoint !==
        sortedLatestSchedule[index].setpoint ||
      sortedPendingSchedule[index].on !== sortedLatestSchedule[index].on
    ) {
      return false;
    }
  }
  return true;
}

export const compareSchedule = (pendingSchedule, currentSchedule) => {
  const result = { isTheSame: true, numberOfDifferences: 0 };

  validDays.forEach(day => {
    const pendingDay = pendingSchedule.filter(item => item.day === day);
    const currentDay = currentSchedule.filter(item => item.day === day);

    if (currentDay !== undefined) {
      const isTheSame = compareDaySchedules(pendingDay, currentDay);
      if (isTheSame === false) {
        result.numberOfDifferences += 1;
      }
      result.isTheSame = result.isTheSame && isTheSame;
    }
  });

  return result;
};

export const calculatePeriodsForSimpleSchedule = simpleSchedule => {
  if (!simpleSchedule) {
    return null;
  }

  const nightStartInMins = simpleSchedule.nightStartTime;
  const morningStartInMins = simpleSchedule.morningStartTime;

  const newSchedule = validDays.map(day => {
    return [
      {
        day,
        startTime: nightStartInMins,
        setpoint: simpleSchedule.nightSetpoint,
      },
      {
        day,
        startTime: morningStartInMins,
        setpoint: simpleSchedule.morningSetpoint,
      },
    ];
  });

  return newSchedule.flat();
};
